import React from 'react'
import {useStaticQuery, graphql} from 'gatsby'

import styles from './pricing-faq-section.module.scss'
import PricingFaqQuestion from './pricing-faq-question'

const PricingFaqSection = () => {
  const data = useStaticQuery(graphql`
  {
    allMarkdownRemark(
      filter: {fileAbsolutePath: {glob: "**/docs/pricing/*.md"}},
      sort: {fields: frontmatter___priority, order: ASC}
    ) {
      edges {
        node {
          fileAbsolutePath
          frontmatter {
            title
          }
          html
          id
        }
      }
    }
  }
`)

  return (
    <section className='light'>
      <h2 id='faq' className={`text-center ${styles.sectionTitle}`}>
        Pricing FAQ
      </h2>
      <div className={styles.questions}>
        {data.allMarkdownRemark.edges.map(({node}) => {
          const {frontmatter, html, id} = node
          const {title} = frontmatter
          return <PricingFaqQuestion qid={id} key={title} title={title} html={html} />
        })}
      </div>
    </section>
  )
}

export default PricingFaqSection
